<template>
  <a :class="hasNewNotification ? 'notification-container' : 'notification-container notification-margin'">
    <div
      v-if="hasNewNotification"
      class="new"
    />
    <NotificationsContainer />
  </a>
</template>

<script>
import NotificationsContainer from '@containers/Notifications/NotificationsContainer'
export default {
  components: { NotificationsContainer },
  props: {
    hasNewNotification: Boolean
  }
}
</script>

<style lang="scss" scoped>
.notification-container{
  display: flex;

  .new {
    position: relative;
    background-color: red;
    height: 10px;
    width: 10px;
    border-radius: 100px;
    top: 0px;
    left: 35px;
  }
}

.notification-margin {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar/NotificationNavbar.vue